import React from "react";
import { AppBar, Toolbar, Typography, Button, MenuItem, ButtonGroup } from "@mui/material";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { signOutAuth, updateOrdersList, updateSelectedRestaurant } from "@src/app/actions/userActions";
import { useDispatch, connect } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import HomeIcon from '@mui/icons-material/Home';
import BackIcon from '@mui/icons-material/ArrowBack';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import InventoryIcon from '@mui/icons-material/Inventory';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import Divider from '@mui/material/Divider';
import BrandLogo from '@components/BrandLogo';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FooterLinks from '@src/app/components/FooterLinks';
import ExposureIcon from '@mui/icons-material/Exposure';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { hasPermission } from '@src/utilities/common';
import { NotificationBell } from '@notifications';

import Select from '@components/Select';
import './Header.scss';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

const Header: React.FC = ({ user, resOptions, selectedRestaurant, restaurants, selectedRestId, roles, userPermissions }: any) => {
    const auth = getAuth();
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();
    const haveRoomBookingPermissions = hasPermission(userPermissions, "roomBookings", "write");
    const canReadOnlineOrders = hasPermission(userPermissions, "onlineOrders", "read");
    const canReadReport = hasPermission(userPermissions, "reports", "read");
    const canReadAnalytics = hasPermission(userPermissions, "analytics", "read");

    const handleLogout = async () => {
        signOut(auth).then(() => {
            dispatch(signOutAuth({}));
            dispatch(updateOrdersList({}));
            navigate('/login');
        });
    };
    const [state, setState] = React.useState({
        left: false,
    });
    const [resData, setResData] = React.useState(resOptions);

    React.useEffect(() => {
        setResData(resOptions);
    }, [resOptions]);

    React.useEffect(() => {
        // handleChange(params?.restaurantId);
        if (!!user?.phoneNumber && params?.restaurantId !== selectedRestId) {
            handleChange(params?.restaurantId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: run when route/selectedRestId change only
    }, [params?.restaurantId, selectedRestId]);

    const toggleDrawer =
        (anchor: Anchor, open: boolean) =>
            (event: React.KeyboardEvent | React.MouseEvent) => {
                if (
                    event &&
                    event.type === 'keydown' &&
                    ((event as React.KeyboardEvent).key === 'Tab' ||
                        (event as React.KeyboardEvent).key === 'Shift')
                ) {
                    return;
                }

                setState({ ...state, [anchor]: open });
            };
    const handleChange = (val: any) => {
        setResData(val);
        if (val && !!roles && Object.keys(roles)?.length) {
            const dataM: any = [...restaurants?.filter((r: any) => r?.docId === val)];
            dataM?.length && dispatch(updateSelectedRestaurant(dataM[0]));
            navigate(`/admin/${val}/orders`);
        }
    }

    const list = (anchor: Anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className="navFlexWrap">
                {user?.name && selectedRestId &&
                    <Link className="userInfoNav" to={`/admin/${selectedRestId}/profile`} data-user={roles[selectedRestId]?.role || 'NA'}>
                        <AccountCircleIcon sx={{ margin: '-8px 4px' }} />
                        {user?.name}
                        <ChevronRightIcon sx={{ marginLeft: 'auto' }} />
                    </Link>
                }
                {!!user?.phoneNumber && <div className="resOptionsWrap" onClick={(e) => e.stopPropagation()}>
                    <Select
                        key={selectedRestId}
                        className="resOptionsHeader"
                        defaultValue={{ label: selectedRestaurant?.name, value: selectedRestId }}
                        options={resData}
                        onChange={(val: any) => handleChange(val?.value)}
                    />
                </div>}
                {/* <div className="menuLink">
                    <Link to={!!user?.role?.admin ? '/admin' : '/'}><HomeIcon color="secondary" /> Orders</Link>
                </div> */}
                {!user?.phoneNumber && <>
                    <div className="menuLink">
                        <Link className="btn-link" to={`/`}><HomeIcon color="secondary" /> Home</Link>
                    </div>
                    <Divider />
                    <div className="menuLink">
                        <Link className="btn-link" to={`/login`}><LoginIcon color="secondary" />Login</Link>
                    </div>

                </>
                }
                {!!user?.phoneNumber && <>
                    <Divider />
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/orders`}><HomeIcon color="secondary" />Orders</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/pos`}><PointOfSaleIcon color="secondary" />POS</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/room-billing`}><ReceiptIcon color="secondary" />Rooms</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/khaata`}><ExposureIcon color="secondary" />Khaata</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && ['admin', 'manager'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/inventory`}><InventoryIcon color="secondary" />Inventory</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && (['admin'].includes(roles[selectedRestId]?.role) || canReadReport) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/report`}><AnalyticsIcon color="secondary" />Report</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && (['admin'].includes(roles[selectedRestId]?.role) || canReadAnalytics) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/analytics`}><AnalyticsIcon color="secondary" />Analytics</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && (['admin'].includes(roles[selectedRestId]?.role) || haveRoomBookingPermissions) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/room-booking`}><AnalyticsIcon color="secondary" />Room Booking</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && (['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) || canReadOnlineOrders) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/online-orders`}><ShoppingBagIcon color="secondary" />Online Orders</Link>
                    </div><Divider /></>}

                    {/* {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/table-booking`}><AnalyticsIcon color="secondary" />  Table Booking</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/table-booking/user`}><AnalyticsIcon color="secondary" />  Table Booking - User</Link>
                    </div><Divider /></>}
                    
                    {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/room-booking`}><AnalyticsIcon color="secondary" />  Room Booking</Link>
                    </div><Divider /></>}
                    
                    {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/room-booking/user`}><AnalyticsIcon color="secondary" />  Room Booking - User</Link>
                    </div><Divider /></>} */}

                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/profile`}><AssignmentIndIcon color="secondary" />Profile</Link>
                    </div><Divider /></>}

                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <><div className="menuLink">
                        <Link to={`/admin/${selectedRestId}/pos-v2`}><PointOfSaleIcon color="secondary" />POS V2</Link>
                    </div><Divider /></>}

                    <div className="menuLink"><button type="button" className="linkButton" onClick={() => handleLogout()}><LogoutIcon color="secondary" />Logout</button></div>
                </>}
                <Divider />
                <div style={{ marginTop: 'auto' }}>
                    <FooterLinks short alignCenter />
                </div>
            </div>
            <div className="menuLink version" >{process.env.REACT_APP_VERSION || "****"}</div>
        </Box>
    );
    return (
        <AppBar position="static" className="headerMain">
            <Toolbar>
                <ButtonGroup>
                    <Button color="secondary" style={{ color: "white", borderColor: 'transparent' }} onClick={toggleDrawer("left", true)}><MenuIcon /></Button>
                    <Link className="backBtn" color="secondary" to={roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) ? `/admin/${selectedRestId}/orders` : '/'}><BackIcon /></Link>
                    <Link className="headerLink" to={!!roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) ? `/admin/${selectedRestId}/orders` : '/'}>
                        <BrandLogo width="100px" style={{ verticalAlign: 'middle' }} alt="" />
                        <span className="logoTextSup">POS</span>
                    </Link>
                </ButtonGroup>
                {!user?.phoneNumber && <MenuItem className="loginLink">
                    <Link className="login-header-btn btn-link" to={`/login`}>
                        Login
                        <LoginIcon color="secondary" />
                    </Link>
                </MenuItem>
                }
                {user?.phoneNumber && roles && selectedRestaurant?.name && <Typography className="cafeName" sx={{ fontSize: "1rem" }} variant="body1">{selectedRestaurant?.name}</Typography>}
                {user?.phoneNumber && roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && (
                    <NotificationBell restaurantId={selectedRestId} />
                )}
                <SwipeableDrawer
                    className="menuDrawer"
                    anchor={"left"}
                    open={state["left"]}
                    onClose={toggleDrawer("left", false)}
                    onOpen={toggleDrawer("left", true)}
                >
                    {list("left")}
                </SwipeableDrawer>
            </Toolbar>
        </AppBar>
    );
};

const mapStateToProps = (state: any) => {
    const { user, common } = state;
    let tempResOptions = [];

    for (let i = 0; i < common?.restaurants?.length; i++) {
        tempResOptions.push({
            label: common?.restaurants[i].name,
            value: common?.restaurants[i].docId,
        })
    }

    return {
        user: user?.user,
        selectedRestaurant: common?.selectedRestaurant,
        resOptions: tempResOptions,
        restaurants: common?.restaurants,
        selectedRestId: common?.selectedRestaurant?.docId || "",
        roles: user?.user?.roles || {},
        userPermissions: user?.user?.roles ? {...common?.globalConfig?.permissions, ...(user?.user?.roles[common?.selectedRestaurant?.docId]?.permissions)} : {}
    }
}

export default connect(mapStateToProps)(Header);
